import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "6da69546-30a1-4ae7-a061-d883874f0297", content: "Cochlea", options: {} },
  { id: "937e19ed-c472-48ed-b249-890de6bf98f5", content: "Ventral cochlear nucleus", options: {} },
  { id: "35728e26-96d7-433c-9acc-9d1599b97608", content: "Dorsal cochlear nucleus", options: {} },
  { id: "081ce2a9-b6ba-46cf-b838-6d9851895c22", content: "Auditory cortex", options: {} },
];

const groups = [
  { id: "8bf111cb-d08b-4cf7-86d4-f392af0e3aa0", content: "Inferior colliculus", options: {} },
  { id: "f0514a84-1241-4dc6-a517-5a8a23d769e4", content: "Medial geniculate nucleus", options: {} },
  { id: "7083f24c-2fd9-46e1-855c-f64206681df1", content: "Superior Olivary Complex (SOC)", options: {} },
  { id: "e30d2986-4105-4ac2-889e-05454df6382f", content: "Cochlear nucleus", options: {} },
];

export const task: Task = {
  id: "9ad6176c-2bec-4a20-b535-49576cc01a19",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    orientation: "horizontal",
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "8bf111cb-d08b-4cf7-86d4-f392af0e3aa0",
      itemsId: ["35728e26-96d7-433c-9acc-9d1599b97608", "081ce2a9-b6ba-46cf-b838-6d9851895c22"],
    },
    {
      groupId: "f0514a84-1241-4dc6-a517-5a8a23d769e4",
      itemsId: ["081ce2a9-b6ba-46cf-b838-6d9851895c22"],
    },
    {
      groupId: "7083f24c-2fd9-46e1-855c-f64206681df1",
      itemsId: ["937e19ed-c472-48ed-b249-890de6bf98f5", "35728e26-96d7-433c-9acc-9d1599b97608"],
    },
    {
      groupId: "e30d2986-4105-4ac2-889e-05454df6382f",
      itemsId: ["6da69546-30a1-4ae7-a061-d883874f0297"],
    },
  ],
};
